'use client';

import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import './App.css';

function App() {
  return (
    <div className="App">
      <TitleSection />
    </div>
  );
}

const TitleSection = () => {
  return (
    <div className="bg-white">
      <div className="relative isolate py-14">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl text-center">
            <h1 className="text-balance text-3xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
              Seidlings b.v.
            </h1>
          </div>
          <div className="mt-16 flow-root sm:mt-12">
            <div className="-m-2 rounded-xl lg:-m-4 lg:rounded-2xl lg:p-4">
              <img
                alt="App screenshot"
                src="/seidlings.jpg"
                width={1792}
                height={1024}
                className="rounded-md"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export default App;
